import type { JSX } from 'react'

import {
  CommentIcon,
  HeartIcon,
  RestackIcon,
  ShareIcon,
} from '../../../../assets/substack'

import styles from './SubstackNote.module.css'

const ICON_SIZE = 18

export const SubstackNoteActions = (): JSX.Element => (
  <div className={styles.actions} data-testid="substack-actions">
    <HeartIcon
      className={styles.icon}
      data-testid="substack-action-heart"
      size={ICON_SIZE}
    />
    <CommentIcon
      className={styles.icon}
      data-testid="substack-action-comment"
      size={ICON_SIZE}
    />
    <RestackIcon
      className={styles.icon}
      data-testid="substack-action-restack"
      size={ICON_SIZE}
    />
    <ShareIcon
      className={styles.icon}
      data-testid="substack-action-share"
      size={ICON_SIZE}
    />
  </div>
)
